import React from 'react';
import SystemGeoSetupRun from "../containers/SystemGeoSetupRun/SystemGeoSetupRun";

export const SystemGeoSetupPage: React.FC = () => <SystemGeoSetupRun />;

